//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { MODES } from './RequestWorkTypeReportInclusionMode.js'
import RequestWorkTypeReportInclusionModeEditor from './RequestWorkTypeReportInclusionModeEditor.vue'

export default {
  name: 'RequestWorkTypeReportInclusionMode',
  props: {
    workType: {
      type: Object,
      required: true
    },
    workTypeInitial: {
      type: Object,
      default () {
        return null
      }
    },
    request: {
      type: Object,
      required: true
    },
    editable: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
    }
  },
  computed: {
    mode: function () {
      return MODES.find(mode => mode.active(this.workType)) || {}
    },
    isStoppedAndHasLastAppliedMode: function () {
      return this.workType.inclusionMode === 'stopped' && this.workType.lastAppliedInclusionMode && this.workType.lastAppliedInclusionMode !== 'stopped'
    },
    includedInPreviousReport: function () {
      return !this.request.hasNotReadyReport && this.workType.includedInCurrentReport
    },
    includedInCurrentNotReadyReport: function () {
      return this.request.hasNotReadyReport && this.workType.includedInCurrentReport
    },
    willBeIncludedInNextReport: function () {
      return !this.request.hasNotReadyReport && this.workType.inclusionMode !== 'stopped'
    },
    icon: function () {
      if (this.isStoppedAndHasLastAppliedMode) {
        const lastAppliedInclusionMode = MODES.find(mode => mode.key === this.workType.lastAppliedInclusionMode)
        if (lastAppliedInclusionMode) {
          return lastAppliedInclusionMode.icon || 'mdi-help'
        }
        return 'mdi-help'
      } else {
        return this.mode.icon || 'mdi-help'
      }
    }
  },
  methods: {
    onEditReportInclusionMode: function () {
      const dialog = this.$d.dialog(this).show({
        headerLabel: 'Выбрать режим автоматического добавления работы',
        contentWidth: 1200,
        contentComponent: RequestWorkTypeReportInclusionModeEditor,
        contentProps: {
          workType: this.workType,
          request: this.request,
          workTypeInitial: this.workTypeInitial
        },
        componentHandlers: {
          select: (event) => {
            this.$emit('select', event)
            dialog.hide()
          },
          cancel: () => {
            dialog.hide()
          }
        }
      })
    }
  }
}
